<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
    <div
        data-slot="dialog-body"
        :class="cn('flex-1 overflow-y-auto px-5 pb-5', props.class)"
    >
        <slot />
    </div>
</template>
